import { FunctionComponent as F, useState, memo } from "react";
import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from '@mui/material/Divider';
import { Box } from "@mui/material";
import MyProtocolsList from "./MyProtocolsList";
import AddProtocol from "./AddProtocol";
import SharedWithMe from "./SharedWithMe";
import AddFolder from "./AddFolder";
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";



const Drawer: F = memo(() =>
{
  const premium = useSelector((state: IState) => state.user.premium);

  const width = 275;

  const StyledDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: { width: theme.spacing(9) } }) } }));

  const [open, setOpen] = useState<boolean>(false);

  return (
    <StyledDrawer variant="permanent" open={open}>

      <Toolbar sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', px: [1] }}>
        <IconButton onClick={() => setOpen(!open)}>
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Toolbar>

      <Divider sx={{ my: 1 }}/>

      <Box sx={{ pl: 1, pr: 2 }}>
        {premium ? <AddFolder drawerOpen={open}/> : <></>}
        <MyProtocolsList drawerOpen={open}/>
        <AddProtocol drawerOpen={open}/>
      </Box>

      <Divider sx={{ my: 1 }}/>

      <SharedWithMe drawerOpen={open} />

    </StyledDrawer>);
})

export default Drawer;